import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
// import enNs1 from './locales/en.json';
// import nlNs1 from './locales/nl.json';
// import frNs1 from './locales/fr.json';

export const defaultNS = 'nl';
export const fallbackNS = 'nl';

if (!i18next.isInitialized) {
  i18next.use(LanguageDetector).use(initReactI18next).use(XHR).init({
    debug: false,
    fallbackLng: 'nl',
    supportedLngs: ['en', 'nl', 'fr'],
    defaultNS: 'translations',
    ns: 'translations',
    nonExplicitSupportedLngs: true,
    detection: {
      lookupQuerystring: 'locale'
    },
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      useSuspense: false
    },
    fallbackNS,
    // resources: {
    //   en: {
    //     ns1: enNs1
    //   },
    //   nl: {
    //     ns1: nlNs1,
    //   },
    //   fr: {
    //     ns1: frNs1,
    //   },
    // },
    backend: {
      loadPath: 'https://api.cribeon.io/locales/{{lng}}/{{ns}}.json',
      crossDomain: true
    }
  });
}

export default i18next;